import { getLoggedInUserInfo } from 'src/models/appConfig/selectors';
import { getState } from 'src/store';
import { isDev } from 'src/workspace/utils';
import axios from 'workspace/axios';

const trackingUrl = isDev()
  ? 'http://localhost:3011/frontend'
  : 'https://frontend.getvymo.com/frontend';

export const trackEvent = (eventId: string, data?: Object) => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.log(eventId, data);
    return;
  }
  axios.post(
    `${trackingUrl}/api/tracking`,
    {
      userId: getLoggedInUserInfo(getState()).email,
      event: eventId,
      env: process.env.APP_ENV,
      data,
      client: getLoggedInUserInfo(getState()).clientCode ?? window.portalId,
      app: window.APP,
    },
    {
      headers: {
        'x-frontendboard-token': process.env.X_FRONTEND_TOKEN,
      },
    },
  );
};
